import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../../store/actions/modalAction";
import { callApiAction } from "../../store/actions/commonAction";
import { Delete, Edit } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import MessageDilog from "../../components/texts/MessageDilog";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import ProductListUi from "./ProductListUi";
import CreateProductController from "./CreateProductController";
import { DeleteProductApi, getProdutApi } from "../../apis/product.api";
import { toTitleCase } from "../../utils/main";

const ActionComponent = memo(({ params, setParams, deleteApi, callBack }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onEdit = () => {
    dispatch(
      openModal(
        <CreateProductController
          id={params._id}
          callBack={callBack}
        />,
        "sm",
        false,
        "update"
      )
    );
  };

  const deleteFun = async (e) => {
    e.preventDefault()
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await deleteApi({ id: params._id }),
        (response) => {
          setParams({});
          setLoading(false);
          dispatch(closeModal("messagedialogdelete"));
          dispatch(callSnackBar(params.name + " Deleted Successfully", SNACK_BAR_VARIETNS.suceess))

        },
        (err) => {
          setLoading(false);
        }
      )

    );


  };

  const onDelete = () => {
    dispatch(
      openModal(
        <MessageDilog
          onSubmit={(e) => deleteFun(e)}
          title="Alert!"
          modalId="messagedialogdelete"
          message={`Are you sure to delete "${params.name || params.title}" ?`}
        />,
        "sm",
        false,
        "messagedialogdelete"
      )
    );
  };

  return (
    <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
      <IconButton size="inherit" onClick={onEdit}>
        <Edit color="info" fontSize="inherit" />
      </IconButton>
      <IconButton disabled={loading} size="inherit" onClick={onDelete}>
        <Delete color="error" fontSize="inherit" />
      </IconButton>
    </Box>
  );
});

const ProductListController = () => {
  const dispatch = useDispatch();
  const title = "Problem ";
  const deleteApi = DeleteProductApi;
  const [loading, setLoading] = useState(false);
  const [list, setlist] = useState()

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["name"],
    sort: "",
    sortDirection: -1,
  });


  const fetchList = useCallback(() => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getProdutApi({ ...filters }),
        (response) => {
          setLoading(false);
          setlist(response);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  }, [dispatch, filters])

  const columns = useMemo(
    () => [
      {
        id: 1,
        fieldName: "name",
        label: "Product Name",
        align: "left",
        sort: true,
        renderValue: (params, setParams) => (
          <Typography textTransform="capitalize">{toTitleCase(params.name)}</Typography>
        ),
      },
      {
        id: 5,
        fieldName: "",
        label: "Action",
        align: "right",
        renderValue: (params, setParams) => (
          <ActionComponent
            deleteApi={deleteApi}
            params={params}
            setParams={setParams}
            callBack={fetchList}
          />
        ),
      },
    ],
    [deleteApi, fetchList]
  );



  useEffect(() => {
    fetchList();
  }, [filters, fetchList])

  return (
    <>
      <ProductListUi
        setlist={setlist}
        list={list}
        title={title}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        columns={columns}
        callBack={fetchList}
      />
    </>
  );
};
export default ProductListController;
